module.exports = __webpack_public_path__ + "static/media/doc-3.be68a94c.jpg";